export type GroupsActionType = 'SET_GROUPS' | 'SET_DYNAMIC' | 'SET_OPEN_CREATE' | 'SET_NEW_GROUPS' | 'SET_UPDATE_GROUP' | 'SET_REMOVE_GROUP' | 'SET_PARTICIPATE_GROUP_ID' | 'SET_OPEN_SELECT_PARTICIPATE' | 'SET_CALLBACK_PARTICIPATE'

export interface GroupsState {
  groups?: { cluster: Cluster, group: Group[] }[]
  dynamic?: ActiveDynamic
  openCreate?: boolean
  participateGroupId?: number | null
  openSelectParticipate?: boolean
  callbackParticipate?: (clusterId?: number) => void
}

export interface ActiveDynamic {
  id: number,
  name: string,
  description: string,
  createdAt: string,
  imageUrl?: string,
  configurationId: number,
  configuration?: string,
  prize: string,
  prizeImageUrl: string,
  prizeReferral:  string,
  prizeReferralImageUrl: string,
  prizeReferred:  string,
  prizeReferredImageUrl: string,
  teamTypeId: number,
  teamType: 'Social' | 'Referred',
  teamStatusId: number,
  teamStatus: string,
  validFrom?: string,
  validTo?: string,
  maxUserInGroup: number,
  maxGroupsForUser: number,
  urlRedirect?: string,
  buttonText?: string,
  urlRedirect2?: string,
  buttonText2?: string
}

export interface Cluster {
  id: number,
  name: string,
  status: boolean,
  createdAt: string,
  imageUrl: string,
  profileIdOwner: number
}

export interface Group {
  id: number
  profileId: number,
  firstName: string,
  teamId: number,
  clusterId: number,
  referredAmount: number,
  referralPoints: number,
  code: string,
  clusterRoleTypeId: number,
  clusterRoleType: 'Dueño',
  points: number
}

export interface RankingGroup {
  name: string,
  teamId: number,
  clusterId: number,
  points: number,
  position: number
  profileId?: number
}

export interface GroupsAction {
  type: GroupsActionType
  payload: [] | ActiveDynamic | boolean | { cluster: Cluster, group: Group }[] | { cluster: Cluster, group: Group[] } | number | ((clusterId?: number) => void)
}

function groupsReducer(state: GroupsState, action: GroupsAction): GroupsState {
  switch (action.type) {
  case 'SET_GROUPS':
    return { ...state, groups: action.payload as { cluster: Cluster, group: Group[] }[] }
  case 'SET_UPDATE_GROUP': {
    const payloadTyped = action.payload as { cluster: Cluster, group: Group[] }
    const currentGroupIndex = state.groups.findIndex((group) => group.cluster.id === payloadTyped.cluster.id)
    const cloneStateGroup = [...state.groups]
    cloneStateGroup[currentGroupIndex] = payloadTyped
    return { ...state, groups: cloneStateGroup }
  }
  case 'SET_REMOVE_GROUP': {
    const payloadTyped = action.payload as number
    const cloneStateGroup = state.groups.filter((group) => group.cluster.id !== payloadTyped)
    return { ...state, groups: cloneStateGroup }
  }
  case 'SET_NEW_GROUPS':
    return { ...state, groups: [...state.groups ?? [] ,action.payload as { cluster: Cluster, group: Group[] }] }
  case 'SET_DYNAMIC':
    return { ...state, dynamic: action.payload as ActiveDynamic }
  case 'SET_OPEN_CREATE':
    return { ...state, openCreate: action.payload as boolean }
  case 'SET_PARTICIPATE_GROUP_ID':
    return { ...state, participateGroupId: action.payload as number | null }
  case 'SET_OPEN_SELECT_PARTICIPATE':
    return { ...state, openSelectParticipate: action.payload as boolean }
  case 'SET_CALLBACK_PARTICIPATE':
    return { ...state, callbackParticipate: action.payload as (clusterId?: number) => void }
  default:
    return state
  }
}

export default groupsReducer
